import { create } from 'zustand';

export type AnnotationType = 'text' | 'rectangle' | 'ellipse';

export type KeyBoardEventStore = {
  continousMode: boolean;
  setContinousMode: (continousMode: boolean) => void;

  snapMode: boolean;
  setSnapMode: (snapMode: boolean) => void;

  enableCrosshair: boolean;
  setEnableCrosshair: (enableCrosshair: boolean) => void;

  isMeasuring: boolean;
  setIsMeasuring: (isMeasuring: boolean) => void;

  // New properties for enhanced measurement functionality
  activeMeasurement: boolean;
  setActiveMeasurement: (active: boolean) => void;

  showMeasurementMenu: boolean;
  setShowMeasurementMenu: (show: boolean) => void;

  measurementMenuPosition: { x: number; y: number };
  setMeasurementMenuPosition: (position: { x: number; y: number }) => void;

  isViewingTakeoffPallette: boolean;
  setIsViewingTakeoffPallette: (isViewingTakeoffPallette: boolean) => void;

  // Takeoff palette visibility modes: 'always' | 'hover' | 'hidden'
  takeoffPaletteVisibilityMode: 'always' | 'hover' | 'hidden';
  setTakeoffPaletteVisibilityMode: (mode: 'always' | 'hover' | 'hidden') => void;

  isViewingFileManager: boolean;
  setIsViewingFileManager: (isViewingFileManager: boolean) => void;

  showChatWindow: boolean;
  setShowChatWindow: (show: boolean) => void;

  // New properties for annotations
  isAnnotating: boolean;
  setIsAnnotating: (isAnnotating: boolean) => void;

  activeAnnotationType: AnnotationType | null;
  setActiveAnnotationType: (type: AnnotationType | null) => void;
};

export const useKeyBoardEventStore = create<KeyBoardEventStore>(set => ({
  continousMode: true,
  setContinousMode: mode => set({ continousMode: mode }),

  snapMode: true,
  setSnapMode: mode => set({ snapMode: mode }),

  enableCrosshair: false,
  setEnableCrosshair: enableCrosshair => set({ enableCrosshair: enableCrosshair }),

  isMeasuring: false,
  setIsMeasuring: measuring => set({ isMeasuring: measuring }),

  // Initialize new properties
  activeMeasurement: false,
  setActiveMeasurement: active => set({ activeMeasurement: active }),

  showMeasurementMenu: false,
  setShowMeasurementMenu: show => set({ showMeasurementMenu: show }),

  measurementMenuPosition: { x: 0, y: 0 },
  setMeasurementMenuPosition: position => set({ measurementMenuPosition: position }),

  isViewingTakeoffPallette: true,
  setIsViewingTakeoffPallette: isViewingTakeoffPallette =>
    set({ isViewingTakeoffPallette: isViewingTakeoffPallette }),

  takeoffPaletteVisibilityMode: 'always',
  setTakeoffPaletteVisibilityMode: (mode: 'always' | 'hover' | 'hidden') =>
    set({ takeoffPaletteVisibilityMode: mode }),

  isViewingFileManager: false,
  setIsViewingFileManager: isViewingFileManager =>
    set({ isViewingFileManager: isViewingFileManager }),

  showChatWindow: false,
  setShowChatWindow: show => set({ showChatWindow: show }),

  // Initialize annotation properties
  isAnnotating: false,
  setIsAnnotating: isAnnotating => set({ isAnnotating: isAnnotating }),

  activeAnnotationType: null,
  setActiveAnnotationType: type => set({ activeAnnotationType: type }),
}));
